import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { EventResource } from 'src/app/interfaces/event-resource';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { EventService } from 'src/app/services/event.service';
import { PartnerService } from 'src/app/services/partner.service';
import { StatsService } from 'src/app/services/stats.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { McpService } from 'src/app/services/mcp.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { NavigationExtras, Router } from '@angular/router';
import { Interest } from 'src/app/interfaces/interest';
import { Configs } from './chart-configs'
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { PdfService } from 'src/app/services/pdf.service';
import { map } from 'rxjs/operators';
import 'jspdf-autotable'
/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state: boolean;
}
/**
 * The Object used to load GoogleCharts
 */
declare var google: any;
/**
 * @ignore
 */
/**
 * @ignore
 */
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  @ViewChild('userChart') userChart: ElementRef;
  @ViewChild('savingsChart') savingsChart: ElementRef;
  @ViewChild('attendenceChart') attendenceChart: ElementRef;
  @ViewChild('donutchart_0') donutchart_0: ElementRef;
  @ViewChild('donutchart_1') donutchart_1: ElementRef;
  @ViewChild('donutchart_2') donutchart_2: ElementRef;
  @ViewChild('donutchart_0_flop') donutchart_0_flop: ElementRef;
  @ViewChild('donutchart_1_flop') donutchart_1_flop: ElementRef;
  @ViewChild('donutchart_2_flop') donutchart_2_flop: ElementRef;

  fiterForm: UntypedFormGroup;
  filterTestForm: UntypedFormGroup;
  public allEventsSortedBytotalActiveReservationsCount = [];

  SubCustomerCount: number = 0;
  partnerCount$ = this.partnerService.partnerCount$;
  eventCount$ = this.eventService.eventCount$;
  alleventCount$ = this.eventService.alleventCount$;

  public top1Event: EventResource = null;
  public top2Event: EventResource = null;
  public top3Event: EventResource = null;
  public flop1Event: EventResource = null;
  public flop2Event: EventResource = null;
  public flop3Event: EventResource = null;
  public sortOptions: SortOption[] = [];
  public events: SortOption[] = [];

  finishedLoadingFlopsAndTops: boolean = true;
  pdfIsDownloadable: boolean = true;
  pdfIsGenerating: boolean = false;
  showUserDataAsTable: boolean = false;
  googlePlayStoreStatsError = true;
  appleAppStoreStatsError = true;
  finishedLoadingTree: boolean = false;
  notEnoughEvents: boolean = false;
  finishedLoadingLineChartUserCount: boolean = false;
  finishedLoadingCalendeData: boolean = false;
  finishedLoadingTypes: boolean = false;
  startDate: Date = new Date();
  maxDate: Date = new Date();
  googlePlayStoreStats = null;
  appleAppStoreStats = null;
  heighCalender = "1600px;"
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];

  clientConfig;
  config;
  subusers = [];
  users = [];
  savings = [];
  data_donut_types = [];
  data_donut_eventLimits = [];
  data_donut_voucherStrats = [];
  data_usercount = [];
  data_saving = [];
  data_attendence = [];
  data_interest = [];
  data_partners = [];
  data_savings = [];
  data_word_cloud = []
  treeData = [];
  data_reservations_line = [];
  filteredOptions = [];
  filteredOptions_2 = [];
  filteredOptions_3 = [];
  optionsAuto = [];
  allActiveEvents = [];
  dataTemp = [];
  eventFilter = ['ACTIVE']


  config_donut = Configs.config_donut;
  config_donut_types = Configs.config_donut_types;
  options_line = Configs.options_line;
  data_radar = Configs.data_radar;
  options_radar = Configs.options_radar;
  options_line_simple = Configs.options_line_simple;
  options_line_partners = Configs.options_line_partners;
  options_line_savings = Configs.options_line_savings;
  tree_options = Configs.tree_options;
  treemap_options = Configs.treemap_options;
  config_donut_users = Configs.config_donut_users;
  options_line_year = Configs.options_line_year;
  options_word_cloud = Configs.options_word_cloud;
  options_line_reservations = Configs.options_line_reservations;

  finishedLoadingComparison: boolean = true;
  hasEventV2: boolean = true;
  hasEventV1: boolean = true;
  differenceIsLessThan61: boolean = false;
  isCalenderChartEmpty: boolean = true;
  allEvents: boolean = false;

  constructor(
    private statsService: StatsService,
    private eventService: EventService,
    private partnerService: PartnerService,
    private fb: UntypedFormBuilder,
    private businessuserService: BusinessuserService,
    private router: Router,
    private overlayService: OverlayService,
    private mcp: McpService,
    private pdfService: PdfService) {

    google.charts.load('current', { 'packages': ["calendar"], 'language': 'de' });
    this.startDate.setMonth(this.startDate.getMonth() - 6);

    this.fiterForm = this.fb.group({
      dropDownTime: ["180", []],
      startDate: [this.startDate, []],
      endDate: [new Date(), []],
    });

    this.filterTestForm = this.fb.group({
      serachForEvent: ["", [Validators.required]],
      serachForEvent_2: ["", [Validators.required]],
      serachForEvent_3: ["", [Validators.required]],
    })

    for (let index = 2; index < 12; index++) {
      this.sortOptions.push({
        value: '' + index * 30, viewValue: `Letze ${index} Monate`, state: false
      })
    }
  }


  ngAfterViewInit() {
    this.mcp.loadConfiguration().subscribe((val) => {
      this.clientConfig = val;
      this.drawChart()
    })

    this.partnerService.getPartners(0, 999).subscribe((partners: PagedResources<BusinessEntityResource>) => {
      partners.content.forEach((element, index) => {
        this.eventService.searchForEvents(0, 999, null, null, [`${element.publicId}`], null).subscribe((events: PagedResources<EventResource>) => {
          if (events.content.length != 0) {
            this.treeData.push({
              "name": element.name,
              "children": []
            })
            events.content.forEach(element => {
              this.treeData[this.treeData.length - 1].children.push({
                "name": element.title,
                "children": [],
              })
            });
          }
          this.treeData = [...this.treeData];
          this.finishedLoadingTree = true;
        })
      });
    })
  }

  ngOnInit() {
    this.finishedLoadingComparison = false;
    this.businessuserService.SubCustomerCount$.subscribe(subCutomers => {
      this.SubCustomerCount = subCutomers
    });

    this.eventService.searchForEvents(0, 1, this.eventFilter, null, null, null).subscribe((val: PagedResources<EventResource>) => {
      this.eventService.searchForEvents(0, val.page.totalElements, this.eventFilter, null, null, null).subscribe((val: PagedResources<EventResource>) => {
        this.allActiveEvents = val.content;
        this.filteredOptions = val.content;
        this.filteredOptions_2 = val.content;
        this.filteredOptions_3 = val.content;
      })
    })
    let interestCount = [];
    let partnerCount = [];
    let eventTypes = [];
    let titles = [];
    let titelsWord = [];

    this.eventService.searchForEventsV2(0, 1, this.eventFilter, null, null, null).subscribe((val: PagedResources<EventResource>) => {
      this.eventService.searchForEventsV2(0, val.page.totalElements, this.eventFilter, null, null, null).subscribe((val: PagedResources<EventResource>) => {
        val.content.forEach((element: EventResource) => {
          this.events.push({
            value: element?.publicId, viewValue: element?.title, state: false
          }),
            element.interests.forEach((int: Interest) => {
              interestCount.push(int)
            });


          partnerCount.push(element.eventPartner);
          eventTypes.push(element);
          titles.push(element.title)
        });

        titles.forEach(element => {
          titelsWord = titelsWord.concat(element.split(' '));
        });

        const TitleByCount = titelsWord.reduce((acc, value) => {
          // Group initialization
          if (!acc[value]) {
            acc[value] = [];
          }
          // Grouping
          acc[value].push(value);
          return acc;
        }, {});

        Object.entries(TitleByCount).forEach((element: any) => {
          //Filter out everything that is not a number
          if (isNaN(element[0])) {
            this.data_word_cloud.push({
              "group": element[0],
              "value": element[1].length,
              "word": element[0],
            })
          }

        });

        this.data_word_cloud = [...this.data_word_cloud]

        const interestsByCount = interestCount.reduce((acc, value) => {
          // Group initialization
          if (!acc[value.name]) {
            acc[value.name] = [];
          }
          // Grouping
          acc[value.name].push(value);
          return acc;
        }, {});

        const typesByCount = eventTypes.reduce((acc, value) => {
          // Group initialization
          if (!acc[value.eventDiscount]) {
            acc[value.eventDiscount] = [];
          }
          // Grouping
          acc[value.eventDiscount].push(value);
          return acc;
        }, {});

        const voucherStrategiesByCount = eventTypes.reduce((acc, value) => {
          // Group initialization
          if (!acc[value.voucherKeyStrategy]) {
            acc[value.voucherKeyStrategy] = [];
          }
          // Grouping
          acc[value.voucherKeyStrategy].push(value);
          return acc;
        }, {});


        const partnersByCount = partnerCount.reduce((acc, value) => {
          // Group initialization
          if (!acc[value.name]) {
            acc[value.name] = [];
          }
          // Grouping
          acc[value.name].push(value);
          return acc;
        }, {});

        const eventLimitByCount = eventTypes.reduce((acc, value) => {
          // Group initialization
          if (!acc[value.eventLimit]) {
            acc[value.eventLimit] = [];
          }
          // Grouping
          acc[value.eventLimit].push(value);
          return acc;
        }, {});

        const savingInPercentByCount = eventTypes.reduce((acc, value) => {
          // Group initialization
          if (!acc[value.savingInPercent]) {
            acc[value.savingInPercent] = [];
          }
          // Grouping
          acc[value.savingInPercent].push(value);
          return acc;
        }, {});



        Object.entries(savingInPercentByCount).forEach((element: any) => {
          this.data_savings.push({
            "group": element[0] + " %",
            "value": element[1].length
          })
        });


        Object.entries(partnersByCount).forEach((element: any) => {
          this.data_partners.push({
            "group": element[0],
            "value": element[1].length
          })
        });

        Object.entries(interestsByCount).forEach((element: any) => {
          this.data_interest.push({
            "group": element[0],
            "value": element[1].length
          })
        });

        Object.entries(typesByCount).forEach((element: any) => {
          this.data_donut_types.push({
            "group": this.localeTranslateEventState(element[0]),
            "value": element[1].length
          })
        });

        Object.entries(eventLimitByCount).forEach((element: any) => {
          this.data_donut_eventLimits.push({
            "group": this.localeTranslateEventLimit(element[0]),
            "value": element[1].length
          })
        });

        Object.entries(voucherStrategiesByCount).forEach((element: any) => {
          this.data_donut_voucherStrats.push({
            "group": this.localeTranslateEventVoucherStrats(element[0]),
            "value": element[1].length
          })
        });

        this.data_partners = [...this.data_partners];
        this.data_interest = [...this.data_interest];
        this.data_donut_types = [...this.data_donut_types];
        this.data_donut_eventLimits = [...this.data_donut_eventLimits];
        this.data_donut_voucherStrats = [...this.data_donut_voucherStrats];
        this.data_savings = [...this.data_savings];
        // this.treeData = [...this.treeData];

      })
    })
  }

  moveToEventWithFilter() {
    let navigationExtras: NavigationExtras = {
      state: {
        filterState: ['ACTIVE']
      }
    };
    this.router.navigate(['caseworker/event'], navigationExtras)
  }

  moveToPartnersWithFilter() {
    let navigationExtras: NavigationExtras = {
      state: {
        filterState: ['ACTIVE']
      }
    };
    this.router.navigate(['caseworker/businessentity'], navigationExtras)
  }

  //totalActiveReservationsCount
  drawChart = () => {

    combineLatest([
      this.statsService.getMainUserData(),
      this.statsService.geSubUserData(),
      this.statsService.geSavingsData(),
      this.statsService.getAttendanceData(),
      this.eventService.getTopThreeEvents(this.eventFilter, null, null, null)
    ]).pipe(
      map(([mainUserData, subUserData, savings, attendance, allEventsSorted]) => {
        this.allEventsSortedBytotalActiveReservationsCount = allEventsSorted;
        if (allEventsSorted.length == 0) {
          this.notEnoughEvents = true;
        } else {


          this.top1Event = allEventsSorted[0];
          this.top2Event = allEventsSorted[1];
          this.top3Event = allEventsSorted[2];

          if (allEventsSorted.length >= 1) {
            this.top1Event = allEventsSorted[0];
          }
          if (allEventsSorted.length >= 2) {
            this.top2Event = allEventsSorted[1];
          }
          if (allEventsSorted.length >= 3) {
            this.top3Event = allEventsSorted[2];
          }
          if (allEventsSorted.length >= 4) {
            this.flop1Event = allEventsSorted[allEventsSorted.length - 1];
          }
          if (allEventsSorted.length >= 5) {
            this.flop2Event = allEventsSorted[allEventsSorted.length - 2];
          }
          if (allEventsSorted.length >= 6) {
            this.flop3Event = allEventsSorted[allEventsSorted.length - 3];
          }
          if (allEventsSorted.length >= 3) {
            this.filterTestForm.patchValue({
              serachForEvent: this.top1Event.publicId,
              serachForEvent_2: this.top2Event.publicId,
              serachForEvent_3: this.top3Event.publicId,
            });
            //  this.filterEvents();
          }

          if (mainUserData.year[0].longValue != 0) {
            this.data_usercount.push({
              "group": "Hauptkunden",
              "date": mainUserData.year[0].created,
              "value": mainUserData.year[0].longValue,
            }, {
              "group": "Unterkunden",
              "date": subUserData.year[0].created,
              "value": subUserData.year[0].longValue,
            })
          }

          if (mainUserData.month3[0].longValue != 0) {
            this.data_usercount.push({
              "group": "Hauptkunden",
              "date": mainUserData.month3[0].created,
              "value": mainUserData.month3[0].longValue,
            }, {
              "group": "Unterkunden",
              "date": subUserData.month3[0].created,
              "value": subUserData.month3[0].longValue,
            })
          }

          if (mainUserData.month2[0].longValue != 0) {
            this.data_usercount.push({
              "group": "Hauptkunden",
              "date": mainUserData.month2[0].created,
              "value": mainUserData.month2[0].longValue,
            }, {
              "group": "Unterkunden",
              "date": subUserData.month2[0].created,
              "value": subUserData.month2[0].longValue,
            })
          }
          if (mainUserData.month[0].longValue != 0) {
            this.data_usercount.push({
              "group": "Hauptkunden",
              "date": mainUserData.month[0].created,
              "value": mainUserData.month[0].longValue,
            }, {
              "group": "Unterkunden",
              "date": subUserData.month[0].created,
              "value": subUserData.month[0].longValue,
            })
          }
          if (mainUserData.week[0].longValue != 0) {
            this.data_usercount.push({
              "group": "Hauptkunden",
              "date": mainUserData.week[0].created,
              "value": mainUserData.week[0].longValue,
            }, {
              "group": "Unterkunden",
              "date": subUserData.week[0].created,
              "value": subUserData.week[0].longValue,
            })
          }
          if (mainUserData.yesterday[0].longValue != 0) {
            this.data_usercount.push({
              "group": "Hauptkunden",
              "date": mainUserData.yesterday[0].created,
              "value": mainUserData.yesterday[0].longValue,
            },
              {
                "group": "Unterkunden",
                "date": subUserData.yesterday[0].created,
                "value": subUserData.yesterday[0].longValue,
              }
            )
          }

          this.data_usercount = [...this.data_usercount];
          this.finishedLoadingLineChartUserCount = true;

          if (savings.year.length != 0) {
            if (savings.year[0].bigDecimalValue != 0) {
              this.data_saving.push({
                "group": "Ersparnis",
                "value": savings.year[0].bigDecimalValue,
                "date": savings.year[0].created,
              })
            }
          }

          this.data_saving.push({
            "group": "Ersparnis",
            "value": savings.month3[0].bigDecimalValue,
            "date": savings.month3[0].created,
          })

          this.data_saving.push({
            "group": "Ersparnis",
            "value": savings.month2[0].bigDecimalValue,
            "date": savings.month2[0].created,
          })

          this.data_saving.push({
            "group": "Ersparnis",
            "value": savings.month[0].bigDecimalValue,
            "date": savings.month[0].created,
          })

          this.data_saving.push({
            "group": "Ersparnis",
            "value": savings.week[0].bigDecimalValue,
            "date": savings.week[0].created,
          })

          this.data_saving.push({
            "group": "Ersparnis",
            "value": savings.yesterday[0].bigDecimalValue,
            "date": savings.yesterday[0].created,
          })

          this.data_saving = [...this.data_saving]

          if (attendance.year.length != 0) {

            this.data_attendence.push({
              "group": "Ersparnis",
              "value": attendance.year[0].longValue,
              "date": attendance.year[0].created,
            })
          }

          this.data_attendence.push({
            "group": "Ersparnis",
            "value": attendance.month[0].longValue,
            "date": attendance.month[0].created,
          })

          this.data_attendence.push({
            "group": "Ersparnis",
            "value": attendance.week[0].longValue,
            "date": attendance.week[0].created,
          })

          this.data_attendence = [...this.data_attendence]
        }
      })
    ).subscribe(() => {
      this.finishedLoadingFlopsAndTops = false;
      this.finishedLoadingComparison = false;
      this.finishedLoadingTypes = true;
      this.finishedLoadingLineChartUserCount = true;
      this.finishedLoadingTree = true;
    })
  }

  showAllEvents() {

    if (this.allEvents == true) {
      this.eventFilter = ["ACTIVE", "HIDDEN", "EXPIRED", "ARCHIVED"];
    } else {
      this.eventFilter = ["ACTIVE"];
    }
    this.finishedLoadingLineChartUserCount = false;
    this.finishedLoadingFlopsAndTops = true;
    this.finishedLoadingCalendeData = false;
    this.finishedLoadingTypes = false;
    this.finishedLoadingTree = false;
    this.data_partners = [];
    this.data_interest = [];
    this.data_usercount = [];
    this.data_saving = [];
    this.data_donut_types = [];
    this.data_donut_eventLimits = [];
    this.data_donut_voucherStrats = [];
    this.data_savings = [];
    this.events = [];
    // this.treeData = [];
    this.data_word_cloud = [];
    this.data_reservations_line = [];

    this.top1Event = null;
    this.top2Event = null;
    this.top3Event = null;

    this.ngOnInit();
    this.drawChart();
  }

  generatePDF() {
    this.pdfIsGenerating = true;
    let haslegal_name: Boolean = false;
    let hasemail: Boolean = false;
    let haswebsite: Boolean = false;
    let hasphone: Boolean = false;
    let hasaddress: Boolean = false;
    let hasMAIN_COLOR: Boolean = false;

    this.mcp.getClientProperties().subscribe((val: Array<any>) => {
      val.forEach(element => {
        if (element.key == 'phone') {
          hasphone = true;
        } else if (element.key == 'email') {
          hasemail = true;
        } else if (element.key == 'legal_name') {
          haslegal_name = true;
        } else if (element.key == 'website') {
          haswebsite = true;
        } else if (element.key == 'address') {
          hasaddress = true;
        } else if (element.key == 'MAIN_COLOR') {
          hasMAIN_COLOR = true;
        }
      });

      if (haslegal_name && hasemail && haswebsite && hasphone && hasaddress && hasMAIN_COLOR) {
        if ((this.fiterForm.value.startDate != '') && (this.fiterForm.value.startDate != null)
          && (this.fiterForm.value.endDate != '') && (this.fiterForm.value.endDate != null)) {
          // To calculate the time difference of two dates
          var Difference_In_Time = this.fiterForm.value.endDate.getTime() - this.fiterForm.value.startDate.getTime();
          // To calculate the no. of days between two dates
          var Difference_In_Days = Math.floor(Difference_In_Time / (1000 * 3600 * 24));
          this.pdfService.genPDfReportForAdmin(this.clientConfig, Difference_In_Days, new Date(this.fiterForm.value.startDate).toLocaleDateString(), new Date(this.fiterForm.value.endDate).toLocaleDateString(), this.data_saving, this.data_interest, this.data_partners);
          this.pdfIsGenerating = false;
        }
        else if (this.fiterForm.value.dropDownTime != '') {
          let Difference_In_Days = this.fiterForm.value.dropDownTime - 30;
          this.pdfService.genPDfReportForAdmin(this.clientConfig, Difference_In_Days, null, null, this.data_saving, this.data_interest, this.data_partners);
          this.pdfIsGenerating = false;
        }
      } else {
        this.overlayService.openSnackBar("Bitte Properties im MCP nachtragen");
        this.pdfIsGenerating = false;
      }
    })
  }

  timeChangedByDateRange(e) {
    this.differenceIsLessThan61 = false;
    this.fiterForm.markAllAsTouched();
    this.pdfIsDownloadable = false;
    if ((this.fiterForm.value.startDate != '') && (this.fiterForm.value.startDate != null)
      && (this.fiterForm.value.endDate != '') && (this.fiterForm.value.endDate != null)) {

      // To calculate the time difference of two dates
      var Difference_In_Time = new Date(this.fiterForm.value.endDate).getTime() - new Date(this.fiterForm.value.startDate).getTime();
      // To calculate the no. of days between two dates
      var Difference_In_Days = Math.floor(Difference_In_Time / (1000 * 3600 * 24));
      if (Difference_In_Days < 60) {
        this.differenceIsLessThan61 = true;
      } else {
        this.finishedLoadingLineChartUserCount = false;
        this.fiterForm.controls.dropDownTime.setValue("");
        this.startDate = this.fiterForm.value.startDate;
        this.combineUpdatedChartData(Difference_In_Days).subscribe(() => {
          this.pdfIsDownloadable = true;
          this.finishedLoadingLineChartUserCount = true;
        })
      }
    }
  }

  timeChangedByDropDown(e) {
    this.finishedLoadingLineChartUserCount = false;
    this.pdfIsDownloadable = false;
    this.fiterForm.controls.startDate.setValue("");
    this.fiterForm.controls.endDate.setValue("");
    let Difference_In_Days = this.fiterForm.value.dropDownTime - 30;
    var d = new Date();
    d.setMonth(d.getMonth() - this.fiterForm.value.dropDownTime / 30);
    this.startDate = d;
    this.combineUpdatedChartData(Difference_In_Days).subscribe(() => {
      this.pdfIsDownloadable = true;
      this.finishedLoadingLineChartUserCount = true;
    })
  }

  combineUpdatedChartData(Difference_In_Days) {
    return combineLatest([
      this.statsService.getSavingsUserDataWithDays(Difference_In_Days),
      this.statsService.getMainUserDataWithDays(Difference_In_Days),
      this.statsService.getSUBUserDataWithDays(Difference_In_Days),
    ]).pipe(
      map(([savings, users, subusers]) => {
        this.subusers = subusers;
        this.users = users;
        this.savings = savings;
        //Usercountchart
        this.data_usercount = [];
        users.forEach((user, index) => {
          if (user[0]?.longValue != 0) {
            this.data_usercount.push(
              {
                "group": "Hauptkunden",
                "date": user[0]?.created,
                "value": user[0]?.longValue
              }, {
              "group": "Unterkunden",
              "date": subusers.at(index)?.[0]?.created,
              "value": subusers.at(index)?.[0]?.longValue,
            }
            )
          }
        });
        this.data_usercount = [...this.data_usercount];
        //Savingschart
        this.data_saving = [];
        savings.forEach(saving => {
          console.log(saving[0]?.bigDecimalValue)
          if (saving[0]?.bigDecimalValue != 0) {
            this.data_saving.push({
              "group": "Ersparnis",
              "date": saving[0]?.created,
              "value": saving[0]?.bigDecimalValue,
            })
          }

        });
        this.data_saving = [...this.data_saving];
      })
    )
  }


  scaleCell(min, max) {
    var cellSize = window.innerWidth / 60;
    if (cellSize > max) return max;
    if (cellSize < min) return min;
    return cellSize;
  }

  toggleUsersToggle(e: MatSlideToggleChange) {
    this.showUserDataAsTable = e.checked;
    if (e.checked == false) {
      this.drawChart();
    }
  }




  localeTranslateEventState(event) {
    switch (event) {
      case "EXTERNAL_EVENT":
        return "Partneraktion";
      case "RAFFLE":
        return "Gewinnspiel";
      case "SERVICE_PLUS":
        return "Exklusiv";
      case "MONETARY":
        return "Preisvorteil";
      default:
        return event;
    }
  }

  localeTranslateEventLimit(limit) {
    switch (limit) {
      case "WITHOUT_LIMIT":
        return "Ohne Einschränkung";
      case "ADULT":
        return "Erwachsene (>= 18 Jahre)";
      case "YOUTH":
        return "unter 18-jährige";
      case "CHILDREN":
        return "Kinder (6-12 Jahre)";
      case "CHILDREN2":
        return "Kinder 2 (8-14 Jahre)";
      case "WOMAN_ONLY":
        return "Frauen (>=18 Jahre)";
      case "MAN_ONLY":
        return "Männer (>= 18 Jahre)";
      case "TEENAGER":
        return "Jugendliche (13-17 Jahre)";
      case "BABYS":
        return "Kleinkinder (0-5 Jahre)";
      default:
        return limit;
    }
  }

  localeTranslateEventVoucherStrats(limit) {
    switch (limit) {
      case "GATES":
        return "Gates Gutscheincodes";
      case "EXTERNAL_SINGLE_KEY":
        return "Aktionspartnercodes (einer)";
      case "EXTERNAL_KEY_LIST":
        return "Aktionspartnercodes (mehrere)";
      default:
        return limit;
    }
  }
}


